<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-btn color="info" @click="addNew" v-if="$can('do','POKO_Kategorie_Opisow_Edycja')">Dodaj kategorie</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                        :items="items"
                        :loading="loading"
                        :hide-default-footer="true"
                        disable-pagination
                        :headers="headers">
                    <template v-slot:item.id="{item}">
                        <v-container fluid>
                            <v-row>
                                <v-col>
                                <v-icon small class="mr-2" @click="editCategory(item)" v-if="$can('do','POKO_Kategorie_Opisow_Edycja')" title="Edytuj">fa-edit</v-icon>
                                <v-icon small class="mr-2"  @click="deleteCategory(item)" v-if="$can('do','POKO_Kategorie_Opisow_Edycja')" title="Usuń">fa-trash-alt</v-icon>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog v-model="showAddCategory" width="768">
            <CategoryEdit v-if="showAddCategory" :edited-object="category" @close="closingEditor"></CategoryEdit>
        </v-dialog>
    </v-container>
</template>

<script>
    import {  mapActions } from "vuex";
    import swal from "sweetalert";
    import {descriptionService} from "../../services";
    import CategoryEdit from "./CategoryEdit";
    export default {
        name: "CategoriesList",
        components: {CategoryEdit},
        data() {
            return {
                loading: true,
                showAddCategory: false,
                category: null,
                items: [],
                headers: [
                    { text: 'Nazwa', sortable: true, align: 'left', value: 'description'},
                    { text: 'Akcje', sortable: false, align: 'right', value: 'id'}
                ]
            }
        },
        methods: {
            ...mapActions("title", ["updateTitle"]),
            ...mapActions("alert", ["error", "success"]),
            refreshCategories()
            {
                this.loading = true;
                descriptionService.getAllCategories({ clientId: this.clientid,type: this.type, showAll: true }).then((results)=> {
                    if(results.data && results.data.result)
                    {
                        this.items = results.data.result
                        this.loading = false;
                    }
                }).catch(() => {
                    this.showError(false,"Błąd pobierania kategorii");
                    this.loading = false
                })
            },
            showError(close, text) {
                swal({
                    title: "Błąd",
                    text: text,
                    icon: "warning",
                    button: "OK"
                }).then(() => {
                    this.loading = false;
                    if (close) {
                        this.$emit("close");
                    }
                });
            },
            closingEditor()
            {
              this.showAddCategory = false
              this.refreshCategories()
            },
            addNew()
            {
                this.category = null
                this.showAddCategory = true
            },
            editCategory(edited)
            {
                this.category = edited
                this.showAddCategory = true
            },
            deleteCategory(item)
            {
                swal({
                    title: "Usuwanie kateogrii: "+item.description,
                    text:  "Czy na pewno chcesz usunąć tą kategorie?",
                    icon: "warning",
                    buttons: ["Nie", "Tak"],
                    dangerMode: true
                }).then(confirmed => {
                    if (confirmed) {
                        descriptionService.
                            deleteCategory(item.id)
                            .then(resp => {
                                if (resp.data == null || !resp.data.success) {
                                    throw "Error usuwania kategorii";
                                } else {
                                    this.success("Usunięto");
                                    this.refreshCategories()
                                }
                            })
                            .catch(e => {
                                if(e.response.data != null && e.response.data.error != null)
                                {
                                    let err = e.response.data.error
                                    this.showError(false,err.message)
                                    return
                                }
                                this.showError(false,"Nie można usunąć kategorii");
                            });
                    }
                });
            }
        },
        mounted() {
            this.refreshCategories()
        },
        created() {
            this.updateTitle("Kategorie opisów");
        },
    }
</script>

<style scoped>

</style>